/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import React from 'react';
import { STACK_DIRECTION, STACK_GAP, StackView } from '@veeam/components';

import type { CSSProperties } from 'react';

import { FieldsetTitle } from '../FieldsetTitle';
import { FieldsetSection } from '../FieldsetSection';

import type { FieldsetSectionsProps } from '../FieldsetSection';

export interface FieldsetBlockProps {
    title?: React.ReactNode;
    titleStyles?: CSSProperties;
    sections: FieldsetSectionsProps[];
    sectionsGap?: STACK_GAP;
}

export const FieldsetBlock: React.FC<FieldsetBlockProps> = ({ title, titleStyles, sections, sectionsGap = STACK_GAP.xl }) => (
    <StackView direction={STACK_DIRECTION.column} gap={STACK_GAP.m} size={{ width: '100%' }}>
        {title && <FieldsetTitle title={title} titleStyles={titleStyles} />}

        <StackView direction={STACK_DIRECTION.row} gap={sectionsGap}>
            {sections.map((section, index) => <FieldsetSection key={`FieldsetSection-${index}`} {...section} />)}
        </StackView>
    </StackView>
);
